<template>
    <div class="ks-series-authorization-page">
        <layout>
            <template v-slot:search>
                <div class="search-wrapper">
                    <div class="title"><a-icon type="search"/> 数据筛选</div>
                    <a-divider></a-divider>
                    <a-space>
                        <a-input allow-clear placeholder="快手号id" v-model="queryParam.out_id"/>
                        <a-input allow-clear placeholder="快手号昵称" v-model="queryParam.user_name"/>
                        <a-select allow-clear placeholder="状态" v-model="queryParam.status">
                            <a-select-option :value="1">正常</a-select-option>
                            <a-select-option :value="2">失效</a-select-option>
                        </a-select>
                        <a-button type="primary" @click="search">查询</a-button>
                        <a-button @click="resetSearch">重置</a-button>
                    </a-space>
                </div>
            </template>

            <template v-slot:content>
                <vxe-grid
                    v-bind="tableGrid"
                    @page-change="handlePageChange"
                >
                    <template #toolbar_buttons>
                        <a-space class="table-operator">
                            <a-button
                                type="primary"
                                icon="cloud-download"
                                @click="showPull"
                                v-if="accessTo('pull')"
                            >拉取授权</a-button>
                        </a-space>
                    </template>

                    <template #action="{ row }">
                        <div class="actions">
                            <a href="javascript:;" @click="rePull(row)" v-if="accessTo('pull')">重新授权</a>
                            <template v-else>-</template>
                        </div>
                    </template>
                </vxe-grid>
            </template>
        </layout>

        <pull-form
            v-if="showPullForm"
            :showForm.sync="showPullForm"
            @success="refresh"
        />
    </div>
</template>

<style lang="less" scoped>
@import 'KsSeriesAuthorization';
</style>

<script>
import KsSeriesAuthorization from './KsSeriesAuthorization'
export default KsSeriesAuthorization
</script>
